import type { EndpointDef } from "@/features/users/data/endpoints";

/**
 * Búsqueda exacta de un endpoint por su `id` (path HTTP).
 * El id del catálogo siempre es el path con `/` inicial, que es lo que
 * se envía al backend en `permissions`.
 */
export function getEndpointById(
  id: string,
  endpoints: EndpointDef[]
): EndpointDef | undefined {
  return endpoints.find((ep) => ep.id === id);
}
